/**
 * HomeARDemoStockPageContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARDemoStockPageContent
 */

import { useHomeARDemoStockPageContentLogic } from '@/hooks/traits/useHomeARDemoStockPageContentLogic';
import type { HomeARDemoStockPageContentConfig } from '@/hooks/traits/useHomeARDemoStockPageContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoStockItem } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { HomeARDemoStockPageUnitsChartView } from '@/components/traits/HomeARDemoStockPageUnitsChartView';
import { HomeARDemoStockPageListView } from '@/components/traits/HomeARDemoStockPageListView';
import { HomeARDemoStockPageStatsView } from '@/components/traits/HomeARDemoStockPageStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeARDemoStockPageContentViewProps {
  config?: Partial<HomeARDemoStockPageContentConfig>;
}

export function HomeARDemoStockPageContentView({ config: propsConfig }: HomeARDemoStockPageContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARDemoStockPageContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoStockItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARDemoStockPageContent">
      {slotWriter['main'] === 'INIT' ? (<Stack className="p-3" direction="vertical" gap="md"><Stack gap="none" direction="vertical"><Typography content={renderPatternValue(__t("std-almadar-demo-stock-page:page.title"))} variant="h3" /><Typography variant="small" color="muted" content={renderPatternValue(__t("std-almadar-demo-stock-page:page.subtitle"))} /></Stack><HomeARDemoStockPageStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeARDemoStockPageUnitsChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeARDemoStockPageListView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeARDemoStockPageContentView;
